import Glide from "@theme/glide-esm";
import { sliderRegistry } from "@theme/slider-registry";

function getActivePerView(glide) {
  const breakpoints = glide.settings.breakpoints || {};
  const width = window.innerWidth;
  const sorted = Object.keys(breakpoints)
    .map(Number)
    .sort((a, b) => b - a);

  for (const point of sorted) {
    if (width <= point) {
      return breakpoints[point].perView || glide.settings.perView;
    }
  }

  return glide.settings.perView;
}

function getPageStartIndices(slideCount, perView) {
  if (slideCount <= perView) {
    return [0];
  }

  const maxIndex = slideCount - perView;
  const indices = [0];
  let index = 0;

  while (index < maxIndex) {
    const next = index + perView;

    if (next < maxIndex) {
      index = next;
      indices.push(index);
      continue;
    }

    if (!indices.includes(maxIndex)) {
      indices.push(maxIndex);
    }

    break;
  }

  return indices;
}

function getCurrentPageIndex(glide, pageStarts) {
  const current = glide.index;
  let page = 0;

  for (let i = 0; i < pageStarts.length; i++) {
    if (current >= pageStarts[i]) {
      page = i;
    }
  }

  return page;
}

function updatePagination(glide, root) {
  const controls = root.querySelector(".shavingart__product-glide-controls");
  const bars = root.querySelector(".shavingart__product-glide-bars");
  const counter = root.querySelector(".shavingart__product-glide-counter");

  if (!controls || !bars || !counter) return;

  const pageStarts = getPageStartIndices(
    glide.settings._slideCount,
    getActivePerView(glide),
  );
  const totalPages = pageStarts.length;
  const currentPage = getCurrentPageIndex(glide, pageStarts);

  if (totalPages <= 1) {
    controls.classList.add("is-single-page");
    return;
  }

  controls.classList.remove("is-single-page");
  counter.textContent = `${currentPage + 1} of ${totalPages}`;

  if (bars.childElementCount !== totalPages) {
    bars.innerHTML = "";
    pageStarts.forEach((startIndex, pageIndex) => {
      const bar = document.createElement("button");
      bar.type = "button";
      bar.className = "shavingart__product-glide-bar";
      bar.setAttribute("aria-label", `Go to page ${pageIndex + 1}`);
      bar.addEventListener("click", () => {
        glide.go(`=${startIndex}`);
      });
      bars.appendChild(bar);
    });
  }

  bars.querySelectorAll(".shavingart__product-glide-bar").forEach((bar, i) => {
    bar.classList.toggle("is-active", i === currentPage);
  });
}

function initProductGlide(el) {
  const baseConfig = sliderRegistry.product;
  if (!baseConfig) return;

  const slideCount = el.querySelectorAll(".glide__slides > .glide__slide").length;
  const config = {
    ...baseConfig,
    breakpoints: { ...baseConfig.breakpoints },
  };
  config._slideCount = slideCount;

  const perView = Math.min(getActivePerView({ settings: config }), slideCount);
  if (perView > 0 && perView < config.perView) {
    config.perView = perView;
  }

  const glide = new Glide(el, config);
  const section = el.closest(".shavingart__product-glide");

  glide.on("mount.after", () => {
    if (section) updatePagination(glide, section);
  });

  glide.on("run.after", () => {
    if (section) updatePagination(glide, section);
  });

  glide.mount();

  window.addEventListener("resize", () => {
    if (section) updatePagination(glide, section);
  });
}

function initProductGlides() {
  document.querySelectorAll('[data-slider="product"]').forEach(initProductGlide);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initProductGlides);
} else {
  initProductGlides();
}
